/// <reference path="../../typings/browser.d.ts" />

namespace Application.Common {
    'use strict';

    export class MathUtils {
        /**
         *
         * @param value
         * @param step
         */
        public static calculateCoordinate = (value: number, step: number = 100): number => Math.round(value / step) * step;
    }
}